import { Title } from "../../../../../components/Title";
import claimPayIcon from '../../../../../assets/claim-pay-icon.svg';

export const ServicesTitle = () => <Title title='Services'>
  <img alt='claimpay' src={claimPayIcon} />
</Title>